// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JPqg","label":"styles_label__3HnWU"};